<template>
    <div class="relative w-full h-full flex flex-col overflow-hidden">
		<div class="h-full w-full flex sm:flex-row overflow-hidden">
			<PcLeftbar @openSiderbar="sidebarShow = !sidebarShow"></PcLeftbar>
			<!-- <SwitchSidebarBtn 
				:sidebarShow="sidebarShow"
				@closeSiderbar="sidebarShow = false"
				@openSiderbar="sidebarShow = true"
			></SwitchSidebarBtn> -->
			
			<div class="max-sm:hidden flex-1 overflow-auto relative">
				<Sidebar ref="sidebar" :sidebarShow="sidebarShow" 
					@closeSiderbar="hideSiderbar"
					@handleClick="handleClick"
					:isUpdate="isUpdate"
					:changeOrder="changeOrder"
				></Sidebar>

				<div class='right_container'>
					<!-- <NavBar @openVip="openVipPage"></NavBar> -->
					<nav-bar></nav-bar>
					<!--AI聊天-->
					<div v-if="currentTool.id == 1" class="flex-1 flex flex-col justify-between overflow-hidden -mt-4 pt-4">
						<div class="right_center pcContPadding flex-1 overflow-y-auto flex flex-col mb-10 pt-4" ref="webscroll" @scroll="handleScroll">
							<home-tip @handleClick='handleClick' v-if="Object.keys(currentConversation).length == 0 || currentConversation.message.length == 0"></home-tip>
							<!-- <div v-if="Object.keys(currentConversation).length == 0 || currentConversation.message.length == 0" class="flex-1 flex flex-col  border-b border-[#C2C4CB]">
								<div class="right_tip">
									<img class="absolute w-[250px] h-[162px] left-[29px] top-0 z-10" src="@/assets/img_bg.png" alt="" />
									<div class="flex1 flex flex-col justify-center w-[100%] bg-white pl-[327px] absolute bottom-0 sm:min-h-[120px] rounded-[15px] text-[#333333]">
										<p class="text-[32px]">Hello！</p>
										<p class="text-sm">
											能够学习和理解人类的语言，进行多轮对话 <br />
											回答问题，高效便捷地帮助人们获取信息、知识和灵感
										</p>
									</div>
								</div>
								<div class="shili_box flex-1">
									<div class="shili_box_one">
										<div class="flex flex-col gap-y-5 border-r border-[#C2C4CB]">
											<div class="text-center text-2xl">
												<div class="text-center">
													<img src="@/assets/icon1.png" class="w-[46px] h-[46px] mb-[14px]" alt="">
												</div>
												示例
											</div>
											<div v-for="(item, key) in exampleList" :key="key" @click="handleClick('shili', item)" class="shili_item">
												{{ item }} →
											</div>
										</div>
										<div class="flex flex-col gap-y-4">
											<div class="text-center text-2xl flex-col">
												<div class="text-center">
													<img src="@/assets/icon2.png" class="w-[46px] h-[46px] mb-[14px]" alt="">
												</div>
												限制
											</div>
											<div v-for="(item, key) in tipList" :key="key" class="shili_item">
												{{ item }} →
											</div>
										</div>
									</div>
								</div>
							</div> -->
							<div v-else class="relative w-full h-full">
								<div
									v-for="(item, index) in currentConversation.message"
									:key="index"
								>
									<ChatItem :chatItem="item" :isFetching='isFetching' @handleClick='handleClick'></ChatItem>
								</div>
							</div>
						</div>
						<div class="right_bottom pcContPadding">
							<DepartItem @handleClick='handleClick' ref="templateBox"></DepartItem>
							<div class="right_input">
								<el-input
									class="input_textarea hide-scrollbar"
									type="textarea"
									autosize
									resize='none'
									rows="5"
									placeholder="请输入您想了解的内容，按Shift+Enter换行"
									v-model="inputValue" @keyup.enter.prevent.native="handleKeyDown">
								</el-input>
								<div class="cursor-pointer mx-3">
									<el-button :plain="true" v-if="isFetching" class="waitBtn animate-spin cursor-pointer el-icon-refresh-right text-[20px] text-[#A0A3AE]" @click="wait"></el-button>
									<div v-else>
										<el-button v-if="inputValue.length == 0" :plain="true" class="!border-0 !p-0" @click="needInput">
											<img class="w-[20px] h-[20px]" src="@/assets/icon_send.png" alt="">
										</el-button>
										
										<img v-else @click="send" class="w-[20px] h-[20px]" src="@/assets/icon_send_a.png" alt="">
									</div>
								</div>
							</div>
							<div class="px-5 text-xs text-[#A0A3AE] lenged-[26px]">
								<span class="bot_more text-sm text-[#333]">
									<label v-if="userInfo && !userInfo.is_vip">剩余次数: <span>{{totalNum}}</span></label>
									<!-- 隐藏助手首页购买按钮 -->
									<button v-if="false" @click="handleClick('openVip')">{{ userInfo && userInfo.is_vip ? '会员续费' : '升级会员' }}</button>
								</span>							
								请遵守<span @click="handleClick('rule')"  class="cursor-pointer">《MedliveGPT用户体验规则》</span> | 
								<span @click="handleClick('yinsi')" class="cursor-pointer">《医脉通隐私政策》</span><span class="mt-1">
									本平台产生的内容均由人工智能模型答复，不代表本服务提供者的态度或观点，仅供参考。
								</span>
							</div>
						</div>
					</div>
					<!--PDF阅读助手-->
					<!-- v-if="currentTool.name == 'PDF阅读助手'" -->
					<PDFRead
						v-if="currentTool.id == 2"
						@handleClick="handleClick"
						:currentConversation = 'currentConversation'
						:isFetching = 'isFetching'
					></PDFRead>
					<!-- ai摘要 -->
					<Abstract
						v-if="currentTool.id == 3"
					></Abstract>
					<!-- ai创作 -->
					<div v-if="currentTool.id == 6">
						ai创作
					</div>
					<!-- ai改写 -->
					<div v-if="currentTool.id == 7">
						ai改写
					</div>
				</div>
			</div>
			<!-- 移动端 AI聊天 -->
			<template v-if="currentTool.id == 1">
				<div class="sm:hidden w-full h-full">
					<div class="phone_body w-full h-full pb-16">
						<NavBar @openSiderbar="sidebarShow = true" @toggle="toggle1" :tabIndex='tabIndex'></NavBar>
						<div class="te flex-1 overflow-y-auto pb-[26px]" 
							ref="mobilescroll"
							@scroll="handleScroll"
						>
							<div v-if="tabIndex == 1">
								<DepartItem @handleClick='handleClick'></DepartItem>
							</div>
							<div v-else>
								<div class="px-4 " v-if="Object.keys(currentConversation).length == 0 || currentConversation.message.length == 0">
									<div class="bg-white rounded-[10px] flex flex-row items-center pr-4 ">
										<img class="w-[130px] h-[96px]" src="@/assets/img_bg2.png" alt="" />
										<div class="flex flex-col justify-center rounded-[15px]">
											<p class="text-[18px] font-bold">Hello！<label class="text-sm">我是MedliveGPT</label></p>
											<p class="text-[11px]">
												能够学习和理解人类的语言，进行多轮对话回答问题，高效便捷地帮助人们获取信息、知识和灵感
											</p>
										</div>
									</div>
								</div>
								<div v-else class="relative w-full h-ful" 
									:style="{ fontSize: fontSize + 'px' }">
									<div v-for="(item, index) in currentConversation.message" :key="index">
										<ChatItem :chatItem="item" :isFetching='isFetching'></ChatItem>
									</div>
								</div>
							</div>
						</div>
						<div class="phone_bot pb-1-safe" id="phone_bottom"  v-if="tabIndex == 0">
							<img @click="handleClick('newchat')" class="cursor-pointer w-6 h-6 mr-[10px]" src="@/assets/icon_new.png" alt="">
							<el-input
								class="phone_textarea"
								type="textarea"
								autosize
								@focus="focusEvent"
								@blur='blurEvent'
								resize='none'
								v-model="inputValue" 
								@keyup="handleKeyDown" 
								placeholder="请输入你的问题" 
								rows="5">
							</el-input>
							<div class="cursor-pointer ml-[15px]">
								<img v-if="isFetching" @click="handleClick('close')" class="w-[20px] h-[20px]" src="@/assets/icon_stop.png" alt="">
								<div v-else>
									<img v-if="inputValue.length == 0" class="w-[20px] h-[20px]" src="@/assets/icon_send.png" alt="">
									<img v-else @click="send" class="w-[20px] h-[20px]" src="@/assets/icon_send_a.png" alt="">
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
        </div>
		<div class="fixed bottom-[120px] right-4 " v-show="upTodown">
			<div class="mb-[12px] cursor-pointer" @click="topScroll">
				<img src="@/assets/icon_top.png" alt="">
			</div>
			<div class="cursor-pointer" @click="scrollSmooth">
				<img src="@/assets/icon_bot.png" alt="">
			</div>
		</div>
    </div>
</template>

<script>
import PcLeftbar from "@/components/PcLeftbar.vue";
import Sidebar from "@/components/SidebarComponent.vue";
import SwitchSidebarBtn from "@/components/SwitchSidebarBtn.vue";
import NavBar from "@/components/NavBar.vue";
import {fetchEventSource,EventStreamContentType} from "@microsoft/fetch-event-source";
import DepartItem from "@/components/DepartItem.vue";
import ChatItem from "@/components/ChatItem.vue";
import { checkPlatform } from "@/utils/util";
import HomeTip from "@/components/HomeTip.vue";
import PDFRead from "@/components/pdf/PDFRead.vue";
import Abstract from '@/components/abstract/Abstract.vue'

let content = "";
import { mapState } from "vuex";
export default {
	components: {
		PcLeftbar,
		Sidebar,
		SwitchSidebarBtn,
		NavBar,
		ChatItem,
		DepartItem,
		HomeTip,
		PDFRead,
		Abstract,
	},
	computed:{
		...mapState(['userInfo','fontSize'])
	},
	data() {
		return {
			exampleList: [
				"简单解释一下量子计算",
				"如何辅助中国医生临床决策？",
				"你能给我推荐一本好书吗？",
			],
			tipList: [
				"可能偶尔生成不正确的信息",
				"可能偶尔会产生有害的说明或有偏见的内容",
				"对2021年后世界和事件了解有限",
			],
			sidebarShow: false,
			inputValue: "",
			currentConversation: {}, //当前的会话
			tabIndex: 0, // 手机端列表切换当前的tab下标
			isFetching: false, // 是否在生成中
			time: 0,
			totalNum: 0,
			device: '', // 设备
			upTodown: false, // 底部上下按钮
			isUpdate: false, // 是否更新侧边栏内容
			changeOrder: false, // 改变侧边栏的顺序
			isrequest: false, // 重复点击
			keyboardHeight: 0, // 键盘高度
			phone_bot_height: 0,

			currentTool: {},

			pdfQuestions: [],  // pdf推荐问题暂存
		};
	},
	created(){
		// 左侧切换工具
		this.$bus.$on('toolHandler',(tool)=>{
			this.currentTool = tool
			this.currentConversation = {}
		})
		// pdf 内问答
		this.$bus.$on('pdfSendMessage', (message) => {
			this.sendMessage(message)
		})
		// 解析 pdf 
		this.$bus.$on('pdfParse', (file_data)=>{
			console.log('22222222222222222222222222');
			
			this.pdfResolve(file_data)
		})
		// pdf获取推荐问题
		// this.$bus.$emit('getPDFQuestions',file_data.fileUrl)
		this.$bus.$on('getPDFQuestions', (fileUrl)=>{
			this.getPDFQuestions(fileUrl)
		})
	},
	mounted() {
		this.todayQaNum()
		window.addEventListener('resize', this.resizeHandler);
		this.resizeHandler()
	},
	beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
    },
	methods: {
		focusEvent() {
			setTimeout(function () {
				document.body.scrollTop = document.body.scrollHeight;
			}, 300);
		},
		blurEvent() {
			console.log(document.getElementById('phone_bottom'))
			let dom = document.getElementById('phone_bottom')
			this.phone_bot_height = dom.clientHeight
			console.log(dom.clientHeight)
		},
		todayQaNum(){ //今日问答剩余次数
			let params = {
				token: window.localStorage.getItem('token'),
			}
			this.$api.todayNum(params).then(res => {
				this.totalNum = res.data
			})
		},
		handleScroll(e) {
			const {scrollTop, clientHeight, scrollHeight} = e.target
			console.log(scrollTop, clientHeight, scrollHeight, parseInt(scrollTop + clientHeight))
			this.upTodown = true
			let timer = setTimeout(()=>{
				clearTimeout(timer)
				this.upTodown = false
			}, 3000)
		},
		resizeHandler() {
			let device = '';
			if (window.innerWidth >= 1200) {
				device = 'desktop';
			} else if (window.innerWidth >= 640) {
				device = 'tablet'
			} else {
				device = 'mobile'
			}
			if (device != 'mobile') {
				// this.sidebarShow = true;
			} else {
				this.sidebarShow = false
			}
			this.device = device

			if (checkPlatform() === 'ios') {
				const windowHeight = window.innerHeight;
				const keyboardHeight = Math.abs(windowHeight - this.$el.offsetHeight);
				this.keyboardHeight = keyboardHeight;
				console.log(this.keyboardHeight )
			}
		},
		toggle1(index) { // 切换页面
			this.tabIndex = index
			if(this.tabIndex == 0){
				this.scrollSmooth()
			}
		},
		// openVipPage(){//打开产品页
		// 	this.$router.push('/buyvip')
		// },
		hideSiderbar() {
			if (this.device == 'mobile') {
				this.sidebarShow = false;
			} else {
				this.sidebarShow = false;
			}
		},
		handleKeyDown(event) {
			if (event.key === 'Enter' && !event.shiftKey) {
				event.preventDefault(); // 阻止默认的换行行为
				this.send()
			} else if (event.key === 'Enter' && event.shiftKey) {
				this.inputValue += '\n';
			}
		},
		send() {
			let that = this;
			if (!that.userInfo.is_vip && that.totalNum == 0) {
				that.$confirm('您的剩余次数不足，购买会员', {
					// customClass: 'vip_tip_box',
					showCancelButton: true,
					center: true,
				}).then(() => {
					that.$router.push({
						name: 'buyvip'
					})
				}).catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
						center: true
					});
				});
			} else {
				let value = that.inputValue;
				if (!value.trim()) return;
				that.tabIndex = 0;
				that.inputValue = "";
				that.isFetching = true;
				that.changeOrder = true
				if (that.currentConversation && that.currentConversation.chat_id) {
					that.sendMessage(value)
				} else {
					that.updateChat(value)
				}
				// if (Object.keys(that.currentConversation).length == 0) {
				// 	that.updateChat(value)
				// } else {
				// 	that.sendMessage(value)
				// }
			}
			
		},
		getConversation(value) {
			this.$refs.sidebar.addChat(value)
		},
		sendMessage(value) {
			if (!this.isrequest) {
				this.isrequest = true
				let that = this
				let params = {
					question: value,
					token: window.localStorage.getItem("token"),
					chat_id: that.currentConversation.chat_id
				}
				that.$api.qaCheck(params).then(res => {
					console.log('33333333333')
					console.log(res)
					// return
					if (typeof fetchEventSource !== "undefined") {
						that.abortController = new AbortController(); // 新建一个AbortController实例
						that.currentConversation.message.push({
							role: "user",
							content: value,
							isLoading: false,
							time: ''
						});
						let params = {
							question: value,
							token: window.localStorage.getItem("token"),
							chat_id: that.currentConversation.chat_id
						};
						console.log(params)
						that.currentConversation.message.push({ // push chartgpt返回的数据，默认为 思考中...
							role: 'assistant',
							content: '',
							isLoading: true
						})
						that.$nextTick(() => {
							that.bottomScroll()
						})
						that.isFetching = true
						that.eventSource = new fetchEventSource("/api/qa", {
							withCredentials: true,
							signal: that.abortController.signal,
							method: "POST",
							openWhenHidden: true,
							headers: {
								"Content-Type": "application/json",
							},
							body: JSON.stringify(params),
							onopen(response) { // 接受的消息内容此时为空
								console.log("EventSource连接成功", response);
								const contentType = (response.headers.get("Content-Type") ? response.headers.get("Content-Type") : "").toLowerCase();
								if (response.ok && contentType.indexOf(EventStreamContentType) > -1) {
									return true;
								} else {
									that.abortController.abort();
									this.$message.error("网络请求报错");
								}
							},
							onmessage(message) {
								that.changeOrder = false
								console.log(message, 'message----------->');
								if (!message.data) return;
								if (message.data === "[DONE]") return;
								try {
									const messageData = JSON.parse(message.data);
									console.log(messageData);
									if ("choices" in messageData) {
										const choice = messageData.choices[0];
										const delta = choice.delta;
										content += delta.content ? delta.content : "";
										that.$set(that.currentConversation.message, that.currentConversation.message.length - 1, { // push chartgpt返回的数据，默认为 思考中...
											role: 'assistant',
											content: content,
											isLoading: true
										})
										console.log(that.currentConversation);
										that.$forceUpdate()
										that.$nextTick(() => {
											that.bottomScroll()
										})
									}
									that.$nextTick(() => {
										that.bottomScroll()
									})
								} catch (error) {
									console.log(error);
								}
							},
							onclose() {
								that.todayQaNum()
								that.abortController.abort();
								console.log("EventSource连接断开");
								that.isrequest = false
								that.changeOrder = false
								if (content.length <= 0) {
									console.log('错误-------->')
									that.$set(that.currentConversation.message, that.currentConversation.message.length - 1, { // push chartgpt返回的数据，默认为 思考中...
										role: 'assistant',
										content: '暂无回答',
										isLoading: false
									})
									that.$forceUpdate()
								}
								that.currentConversation.message[that.currentConversation.message.length - 1].isLoading = false
								that.$forceUpdate()
								content = '';
								that.isFetching = false
								// this.$bus.$emit('pdfFetching', false)
								if (that.currentConversation.message.length == 2) {
									that.isUpdate = true
								}
								// 如果时pdf阅读助手 通知发送结束
								// if (this.currentTool.name == 'PDF阅读助手') {
								if (this.currentTool.id == 2) {
									this.$bus.$emit('pdfChatSendEnd')
								}
							},
							onerror(err) {
								console.log(err, '------------>')
								that.isrequest = false
								that.changeOrder = false
								that.isFetching = false;
								// this.$bus.$emit('pdfFetching', false)
								that.abortController.abort();
								// 如果时pdf阅读助手 通知发送结束
								// if (this.currentTool.name == 'PDF阅读助手') {
								if (this.currentTool.id == 2) {
									this.$bus.$emit('pdfChatSendEnd')
								}
								that.$set(that.currentConversation.message, that.currentConversation.message.length - 1, { // push chartgpt返回的数据，默认为 思考中...
									role: 'assistant',
									content: content,
									isLoading: false
								})
								that.$forceUpdate()
								content = '';
								throw err;
							},
						});
					} else {
						that.$message.error("your browser does not support server-sent events...");
					}

				}).catch(()=>{
					that.isFetching = false;
					// this.$bus.$emit('pdfFetching', false)
					that.changeOrder = false;
					that.isrequest = false;
					// 如果时pdf阅读助手 通知发送结束
					// if (this.currentTool.name == 'PDF阅读助手') {
					if (this.currentTool.id == 2) {
						this.$bus.$emit('pdfChatSendEnd')
					}
				})		
			}
			
		},
		pdfResolve(file_data){
			let that = this
			// console.log(JSON.stringify(this.currentConversation));
			if (!this.isrequest) {
				this.isrequest = true
				this.isFetching = true
				this.isFetching = true
				if (typeof fetchEventSource !== "undefined") {
						that.abortController = new AbortController(); // 新建一个AbortController实例
						if(!Array.isArray(that.currentConversation.message)) that.$set(that.currentConversation,'message',[])
						that.currentConversation.message.push({
							role: "user",
							content: file_data.fileName,
							isLoading: false,
						});
						let params = {
							token: window.localStorage.getItem("token"),
							chat_id: file_data.chat_id,
							file_name: file_data.fileName,
							file_url: file_data.fileUrl,
						}
						console.log(params)
						that.currentConversation.message.push({ // push chartgpt返回的数据，默认为 思考中...
							role: 'assistant',
							content: '',
							isLoading: true,
							questions: []
						})
						that.$nextTick(() => {
							that.bottomScroll()
						})
						that.eventSource = new fetchEventSource("/api/pdf-read", {
							withCredentials: true,
							signal: that.abortController.signal,
							method: "POST",
							openWhenHidden: true,
							headers: {
								"Content-Type": "application/json",
							},
							body: JSON.stringify(params),
							onopen(response) { // 接受的消息内容此时为空
								console.log("EventSource连接成功", response);
								const contentType = (response.headers.get("Content-Type") ? response.headers.get("Content-Type") : "").toLowerCase();
								if (response.ok && contentType.indexOf(EventStreamContentType) > -1) {
									return true;
								} else {
									that.abortController.abort();
									this.$message.error("网络请求报错");
								}
							},
							onmessage(message) {
								that.changeOrder = false
								console.log(message, 'message----------->');
								if (!message.data) return;
								if (message.data === "[DONE]") return;
								try {
									const messageData = JSON.parse(message.data);
									console.log(messageData);
									if ("choices" in messageData) {
										const choice = messageData.choices[0];
										const delta = choice.delta;
										content += delta.content ? delta.content : "";
										that.$set(that.currentConversation.message, that.currentConversation.message.length - 1, { // push chartgpt返回的数据，默认为 思考中...
											role: 'assistant',
											content: content,
											isLoading: true,
											questions:[]
										})
										console.log(that.currentConversation);
										that.$forceUpdate()
										that.$nextTick(() => {
											that.bottomScroll()
										})
									}
									that.$nextTick(() => {
										that.bottomScroll()
									})
								} catch (error) {
									console.log(error);
								}
							},
							async onclose() {
								// // pdf阅读结束后 ，获取推荐问题
								// const _data = {
								// 	chat_id: that.currentConversation.chat_id,
								// 	token: window.localStorage.getItem("token"),
								// }
								// const {data} = await that.$api.getPDFQuestions(_data)
								// that.currentConversation.message[that.currentConversation.message.length - 1].questions = data
								// that.$forceUpdate()
								// that.$nextTick(() => {
								// 	that.bottomScroll()
								// })
								that.addPDFQuestions()
								that.abortController.abort();
								console.log("EventSource连接断开");
								that.isrequest = false
								that.changeOrder = false
								if (content.length <= 0) {
									console.log('错误-------->')
									that.$set(that.currentConversation.message, that.currentConversation.message.length - 1, { // push chartgpt返回的数据，默认为 思考中...
										role: 'assistant',
										content: '暂无回答',
										isLoading: false
									})
									that.$forceUpdate()
								}
								that.currentConversation.message[that.currentConversation.message.length - 1].isLoading = false
								that.$forceUpdate()
								content = '';
								that.isFetching = false
								if (that.currentConversation.message.length == 2) {
									that.isUpdate = true
								}
								// 如果时pdf阅读助手 通知发送结束
								// if (that.currentTool.name == 'PDF阅读助手') {
								// 	that.$bus.$emit('pdfChatSendEnd')
								// }


							},
							onerror(err) {
								console.log(err, '------------>')
								that.isrequest = false
								that.changeOrder = false
								this.isFetching = false
								// this.$bus.$emit('pdfFetching', false)
								that.abortController.abort();
								// 如果时pdf阅读助手 通知发送结束
								// if (this.currentTool.name == 'PDF阅读助手') {
									if (this.currentTool.id == 2) {
									this.$bus.$emit('pdfChatSendEnd')
								}
								that.$set(that.currentConversation.message, that.currentConversation.message.length - 1, { // push chartgpt返回的数据，默认为 思考中...
									role: 'assistant',
									content: content,
									isLoading: false
								})
								that.$forceUpdate()
								content = '';
								throw err;
							},
						});
					} else {
						that.$message.error("your browser does not support server-sent events...");
					}

	
			}
		},
		async getPDFQuestions(file_url){
			let that = this;
			// pdf阅读结束后 ，获取推荐问题
			const _data = {
				file_url: file_url,
				token: window.localStorage.getItem("token"),
			}
			const {data} = await that.$api.getPDFQuestions(_data)
			console.log(that.currentConversation);
			that.pdfQuestions = data
			// that.currentConversation.message[that.currentConversation.message.length - 1].questions = data
			// console.log(that.currentConversation);
			// that.$forceUpdate()
			// that.$nextTick(() => {
			// 	that.bottomScroll()
			// })
		},
		addPDFQuestions(){
			let that = this;
			that.currentConversation.message[that.currentConversation.message.length - 1].questions = that.pdfQuestions
			console.log(that.currentConversation);
			that.$forceUpdate()
			that.$nextTick(() => {
				that.bottomScroll()
			})
		},
		updateChat(value) {
			let params = {
				token: window.localStorage.getItem('token'),
				chat_name: value ? value : '',
				tool_id: this.currentTool.id
			}
			this.$api.chatAdd(params).then(res =>{
				this.isUpdate = true
				this.currentConversation.chat_id = res.data
				this.currentConversation.message = []
				this.sendMessage(value)
			})
        },
		
		
		bottomScroll() { // 页面随内容增加滚动到最底部
			// pdf阅读助手时 通知阅读助手聊天页面 滚动
			// if (this.currentTool.name == 'PDF阅读助手') {
			if (this.currentTool.id == 2) {
				this.$bus.$emit('pdfChatScroll')
				return
			}
			if (this.currentTool.id != 1) return

			this.$nextTick(()=>{
				if (this.device !='mobile') {
					let web_scrollEl = this.$refs.webscroll;
					web_scrollEl.scrollTop = web_scrollEl.scrollHeight;
				} else {
					console.log('333333333')
					let mobile_scrollEl = this.$refs.mobilescroll;
					mobile_scrollEl.scrollTop = mobile_scrollEl.scrollHeight;
				}
			})
		},
		scrollSmooth() { // 平滑滚动到底部
			if (this.currentTool.id != 1) return
			this.$nextTick(()=>{
				if (this.device !='mobile') {
					let web_scrollEl = this.$refs.webscroll;
					web_scrollEl.scrollTo({ 
						top: web_scrollEl.scrollHeight, 
						behavior: 'smooth' 
					});
				} else {
					let mobile_scrollEl = this.$refs.mobilescroll;
					mobile_scrollEl.scrollTo({ 
						top: mobile_scrollEl.scrollHeight, 
						behavior: 'smooth' 
					});
				}
			})
		},
		topScroll() {
			this.$nextTick(()=>{
				if (this.device !='mobile') {
					let web_scrollEl = this.$refs.webscroll;
					web_scrollEl.scrollTo({ 
						top: 0, 
						behavior: 'smooth' 
					});
				} else {
					let mobile_scrollEl = this.$refs.mobilescroll;
					mobile_scrollEl.scrollTo({ 
						top: 0, 
						behavior: 'smooth' 
					});
				}
			})
		},
		handleClick(type, currentItem) {
			console.log(type, currentItem)
			// return
			switch (type) {
				case 'close': // 关闭会话
					console.log('11111111111')
					// return
					this.abortController.abort();
					this.$set(this.currentConversation.message, this.currentConversation.message.length-1, { // push chartgpt返回的数据，默认为 思考中...
						role: 'assistant',
						content: content.length > 0 ? content : '暂无回答',
						isLoading: false
					})
					content = ''
					this.$forceUpdate()
					this.isFetching = false
					this.isrequest = false
					this.todayQaNum() 
					break;
				case "newchat": // 新建会话
					this.getConversation()
					if(this.currentTool.id == 1) this.$refs.templateBox.templateShow = false
					break;
				case 'changeConversation': {// 切换会话，会有以前的数据，所以需要处理
						this.currentConversation = currentItem
						console.log(this.currentConversation);
					
						console.log('1231231321231231');
						const items = [...(this.currentConversation.records)]
						const  messages = [];
						let prevContent = '';
						console.log('items',items);
						if (items.length > 0) {
							for (let i = items.length - 1; i >= 0; i--) {
								const item = items[i],
									q = item.question ? item.question : '',
									a = item.answer ? item.answer: '',
									time = item.created_at ? item.created_at.split(' ')[0] : ''
								prevContent = `${prevContent} ${q} ${a}`;
								messages.unshift({ role: 'assistant', content: a, isLoading: false, time:time});
								messages.unshift({ role: 'user', content: q, isLoading: false, time: time});
							}
						}else{
							if (this.currentTool.id != 1) break
							this.$refs.templateBox.templateShow = false
						}
						// console.log(messages);
						this.$set(this.currentConversation,'message',  messages)
						// console.log('============================');
						// console.log(this.currentConversation);
						// console.log('============================');

						this.toggle1(0) //移动端在显示推荐时，切换会话应该一起切换到对话窗口
						this.scrollSmooth()
						break;
					}
				case 'depart': // 推荐和科室切换
				if(!this.isFetching){
					this.inputValue = currentItem
					this.send()
				}else{
					this.wait()
				}
					break
				case 'shili': // 示例推荐
					this.inputValue = currentItem
					this.tabIndex = 0;
					break;
				case 'updateStatus':
					this.isUpdate = false
					break;
				case 'rule':
					window.open(this.$router.resolve({name: 'agreement'}).href, '_blank')
					break;
				case 'yinsi':
					window.open('https://m.medlive.cn/nsp/privacy.php?id=29&_wx=1', '_blank')
					break;
				case "clear": // 清空历史会话
					this.currentConversation = {}
					break;
				case 'openVip'://开通VIP
					this.$router.push('/buyvip')
					break
				default:
					break;
			}
		},
		wait(){ //问题正在回答中，请稍后再试
			this.$message({
				message: '问题回答中，请稍等',
				type: 'warning',
				center:true
			});
		},
		needInput(){
			this.$message({
				message: '请输入问题或点击提问模板选择推荐提问',
				type: 'warning',
				center: true
			});
		}
	}
};
</script>

<style lang='scss' scoped>
.right_container {
	// justify-between
  @apply relative h-full  flex flex-1 flex-col  overflow-auto;
}
.right_bottom {
	@apply w-full pb-8;
	.right_input {
		@apply bg-white mb-4  p-2 border border-solid border-black/20 overflow-hidden rounded-[15px] flex justify-between items-end;
		
	}
  .send_btn {
    @apply ml-1 flex justify-center items-center rounded outline-none hover:bg-gray-900/20;
  }
}
.right_center {
    .right_tip {
        @apply relative max-sm:flex flex-row w-full sm:min-h-[162px] h-[120px] rounded-[15px];
    }
    .shili_box {
        @apply w-full h-full pt-6 sm:pt-[60px] sm:px-0 md:px-2 lg:px-4 xl:px-6 2xl:px-8;
    }
    .shili_box_one {
        @apply grid grid-cols-1 gap-y-10 sm:grid-cols-2 sm:gap-x-6 text-[#333333];
    }
    .shili_item {
        @apply text-base p-2 rounded-md text-center hover:bg-gray-200;
    }
	&::-webkit-scrollbar {
		display: none;
	}
}
.bot_more span {
  color: #fa3550;
  margin: 0 12px 0 4px;
}

.bot_more button {
	@apply mr-5 px-3 py-[2px] border border-[#4c5bdf] text-[#4c5bdf] rounded;
}

.bot_tip {
  font-family: PingFang SC;
  cursor: pointer;
  color: #a0a3ae;
}

// 手机样式
.phone_body {
	@apply flex flex-col justify-between overflow-hidden;
	.phone_bot {
		@apply fixed bottom-0 w-full bg-white px-4  pt-[10px] flex justify-between items-center;
		.phone_textarea {
			@apply flex-1 min-h-full max-h-[112px] w-full text-sm px-4 py-1 rounded-[10px] bg-[#FAF9F9] overflow-auto;
		}
	}
}

</style>
<style lang='scss'>
.input_textarea {
	@apply flex-1 min-h-[73px] max-h-[115px] max-w-[calc(100%-24px)] overflow-y-auto bg-transparent resize-none outline-none pl-[14px];
}
.el-textarea__inner {
	@apply text-sm;
	padding-left: 0 !important;
	padding-right: 0 !important;
	background-color: transparent !important;
	border: none !important;
}
</style>
